import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function Window(props: Props) {
  return (
    <div className={styles.window}>
      <div className={styles.overlay} onClick={props.close} />
      {props.children}
    </div>
  );
}

export { Window };
